import styled, { css } from 'styled-components';

export const FlightContainer = styled.div`
  display: grid;
  grid-template-columns: auto minmax(200px, 1fr) auto;
  align-items: center;
  width: 100%;
  height: 100%;

  [class*='FullTransportLogos__LogoWrapper'] {
    width: 40px;
    height: 40px;
  }

  [class*='FullTransportLogos__LogoContainer'] {
    border: 0px;
  }
`;

export const TransportInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
  padding: 4px 24px;
  overflow: hidden;
`;

export const TransportInfoTime = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
`;

export const TransportTime = styled.div`
  ${(p) => p.theme.kallisto.mixins.font('Title3')};
  display: block;
  white-space: nowrap;
  position: relative;
  flex-grow: 1;
`;

export const TransportPlusDays = styled.div<{ isUS?: boolean }>`
  color: ${(p) => p.theme.commons.colors.warning600};
  width: 20px;
  position: absolute;
  top: -1px;
  left: 140px;

  ${({ isUS }) =>
    isUS &&
    css`
      left: 220px;
    `}
`;

export const TransportInfoAirports = styled.div`
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  color: ${(p) => p.theme.commons.colors.gray400};

  .warning {
    color: ${(p) => p.theme.commons.colors.warning600};
  }
`;

export const TransportStops = styled.div`
  display: block;
  white-space: nowrap;
  padding-left: 12px;
  flex-grow: 2;
`;

export const TransportDuration = styled.div`
  display: block;
  white-space: nowrap;
  flex-grow: 2;
`;
